/**
 * Expose all endpoints for 'reports'.
 */
export const cocreationApiMock = () => ({
  // descarga un archivo
  getCocreationDashboard: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [
            {
              data: [
                {
                  count: 2,
                  value: 66.7,
                  group: "Tiendas de conveniencia"
                },
                {
                  count: 1,
                  value: 33.3,
                  group: "Cafeterías de Cadena"
                }
              ],
              title: "¿En dónde suele consumir café fuera de casa?",
              graph: "pie"
            },
            {
              data: [
                {
                  count: 1,
                  value: 33.3,
                  group: "2 o más veces por semana"
                },
                {
                  count: 1,
                  value: 33.3,
                  group: "Al menos 1 vez por semana"
                },
                {
                  count: 1,
                  value: 33.3,
                  group: "Al menos 1 vez cada 15 días"
                }
              ],
              title: "¿Con qué frecuencia visita cafeterías de cadena?",
              graph: "bar"
            },
            {
              data: [
                {
                  count: 1,
                  value: 33.3,
                  group: "Sí"
                },
                {
                  count: 2,
                  value: 66.7,
                  group: "No"
                }
              ],
              title:
                "¿Le gustaría ser de los primeros en probar nuevos productos que desarrolla la marca?",
              graph: "pie"
            },
            {
              data: [
                {
                  count: 2,
                  value: 66.7,
                  group: "Tiendas de conveniencia"
                },
                {
                  count: 1,
                  value: 33.3,
                  group: "Cafeterías de Cadena"
                }
              ],
              title: "¿En dónde suele consumir café fuera de casa?",
              graph: "pie"
            },
            {
              data: [
                {
                  count: 1,
                  value: 33.3,
                  group: "2 o más veces por semana"
                },
                {
                  count: 1,
                  value: 33.3,
                  group: "Al menos 1 vez por semana"
                },
                {
                  count: 1,
                  value: 33.3,
                  group: "Al menos 1 vez cada 15 días"
                }
              ],
              title: "¿Con qué frecuencia visita cafeterías de cadena?",
              graph: "bar"
            },
            {
              data: [
                {
                  count: 1,
                  value: 33.3,
                  group: "Sí"
                },
                {
                  count: 2,
                  value: 66.7,
                  group: "No"
                }
              ],
              title:
                "¿Le gustaría ser de los primeros en probar nuevos productos que desarrolla la marca?",
              graph: "pie"
            }
          ],
          ok: true
        });
      }, 1000);
    })
});

export const cocreationApi = api => ({
  // el api recibe el nombre del reporte en el path y como query parameters los filtros
  // la lista de nombres de reporte soportados viene en el ca,po 'reports' de account
  getCocreationDashboard: ({ reportName, filters }) => {
    return api.get("dashboard/cocreacion", { ...filters });
  }
});



// WEBPACK FOOTER //
// ./src/services/api/cocreationApi.js